module.exports = {
	"textures": [
		{
			"image": "Particles",
			"format": "RGBA8888",
			"size": {
				"w": 128,
				"h": 512
			},
			"scale": 1,
			"frames": [
				{
					"filename": "blue.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 128
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 128
					},
					"frame": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 128
					}
				},
				{
					"filename": "green.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 128
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 128
					},
					"frame": {
						"x": 0,
						"y": 128,
						"w": 128,
						"h": 128
					}
				},
				{
					"filename": "red.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 128
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 128
					},
					"frame": {
						"x": 0,
						"y": 256,
						"w": 128,
						"h": 128
					}
				},
				{
					"filename": "yellow.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 128
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 128
					},
					"frame": {
						"x": 0,
						"y": 384,
						"w": 128,
						"h": 128
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};